import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";

import { CompanySettingsPage } from "../../pages/settings/";
import Messages from "../../resources/messages/List/List";
import {
	OrderEditByTransporter,
	OrderShowTabsWrapper,
	commonOrdersResourceData,
	ordersResource,
} from "../../resources/orders";
import { authenticatedResources } from "./authenticated";

export const transporterDriverResources = [
	<Resource
		name="orders"
		list={ordersResource.list}
		edit={OrderEditByTransporter}
		show={OrderShowTabsWrapper}
	/>,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource name="ports" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="transporters" intent="registration" />,

	<Resource name="order-statuses" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-pricelist" intent="registration" />,
	<Resource name="trucks" intent="registration" />,
	<Resource name="trailers" intent="registration" />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="terminal" intent="registration" />,
	<Resource name="external-terminal-links" intent="registration" />,
	<Resource name="commodities" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="pallets-and-boxes" intent="registration" />,
	<Resource name="pallets" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,

	// <Resource name="drivers" {...customerDriversResource} />,
	...authenticatedResources,
];

export const transporterDriverRoutes = [<Route exact path="/messages" component={Messages} />];
